import React, { useContext, useEffect, useState } from "react";
import AdminAttendanceSummaryView from "./admin-attendance.view";
import { IAdminAttendanceState } from "../attendance.types";
import dayjs from 'dayjs';
import Locale from "../../../core/locale/locale";
import { StatCardColor } from "../../common/stat-cards/stat-cards";
import { LogOut, TrendingUp, UserRoundCheck, Users, UserX } from "lucide-react";
import { fetchAttendanceChartData, fetchAttendanceCount, fetchEmployeeAttendance } from "./actions";
import AttendanceSearchContext from "../AttendanceContext";
import { scrollToAttendanceTable } from "../utils";

const initialState = {
    summary: {
        date: '',
        activeEmployee: 0,
        present: 0,
        absent: 0,
        onLeave: 0,
        attendanceRate: 0
    },
    chartData: {monthlyTrend: [], dayOfWeekPattern: []},
    isSummaryLoading: false,
    isChartLoading: false,
}

const AdminAttendanceSummary = () => {

    const [state, setState] = useState<IAdminAttendanceState>(initialState);
    const {setAttendanceSearch}=useContext(AttendanceSearchContext);

    useEffect(() => {
        loadSummary();
        loadCharts();
    }, []);

    const loadSummary = async () => {
        setState(prev => ({...prev, isSummaryLoading: true}));

        try {
            const today = dayjs().format(Locale.dateFormat);
            const count = await fetchAttendanceCount(today);

            setState(prev => ({
                ...prev,
                summary: count
            }));
        } finally {
            setState(prev => ({
                ...prev,
                isSummaryLoading: false
            }));
        }
    };

    const loadCharts = async () => {
        setState(prev => ({...prev, isChartLoading: true}));

        try {
            const chartData = await fetchAttendanceChartData();

            setState(prev => ({
                ...prev,
                chartData
            }));
        } finally {
            setState(prev => ({
                ...prev,
                isChartLoading: false
            }));
        }
    };



    const cardData = [
        {
            key: 'attendanceRate',
            label: 'Attendance Rate',
            value: `${state.summary.attendanceRate}%`,
            icon: TrendingUp,
            color: 'teal' as StatCardColor
        },
        {
            key: 'activeEmployee',
            label: 'Total Workforce',
            value: state.summary.activeEmployee,
            icon: Users,
            color: 'blue' as StatCardColor
        },
        {
            key: 'present',
            label: 'Present Today',
            value: state.summary.present,
            icon: UserRoundCheck,
            color: 'green' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'PRESENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'absent',
            label: 'Absent',
            value: state.summary.absent,
            icon: UserX,
            color: 'red' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'ABSENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'onLeave',
            label: 'On Leave',
            value: state.summary.onLeave,
            icon: LogOut,
            color: 'orange' as StatCardColor,
            onClick:()=> {
                setAttendanceSearch('STATUS', 'ON_LEAVE');
                scrollToAttendanceTable();
            }
        },
    ];


    return (
        <AdminAttendanceSummaryView
            chartData={state.chartData}
            cardData={cardData}
            isSummaryLoading={state.isSummaryLoading}
            isChartLoading={state.isChartLoading}
        />
    )
}

export default AdminAttendanceSummary;
